import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";
import { isValidPatientId } from "utils/isValidPatientId";
import { pathGenerators } from "utils/routes";

export const usePatientData = (patientId) => {
  const navigate = useNavigate();
  const currentPatientId = useCurrentPatientId();

  const selectedPatientId =
    patientId != null ? patientId : currentPatientId;

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patient", selectedPatientId, tenantVal],
    queryFn: async () => {
      if (!isValidPatientId(selectedPatientId) || !tenantVal) return null;
      const axiosInstance = createAxiosInstance();

      try {
        const response = await axiosInstance.get(
          `${tenantVal}/patient/get/${selectedPatientId}`
        );

        return response.data;
      } catch (error) {
        const status = error?.response?.status;
        const isNotFound = status === 404;
        const isServerError = status >= 500 && status < 600;

        if (isNotFound || isServerError) {
          navigate(pathGenerators.global.patient());
        }

        throw error;
      }
    },
    enabled: isValidPatientId(selectedPatientId) && !!tenantVal,
    meta: { skipGlobalError: true },
  });
};
